import { render } from "./HomeView.vue?vue&type=template&id=bad20b46"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "@/assets/css/views/HomeView.scss?vue&type=style&index=0&lang=scss"
import "@/assets/css/FileUpload.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__